import { render, staticRenderFns } from "./property-form-page.vue?vue&type=template&id=60f0cefe&scoped=true&"
import script from "./property-form-page.vue?vue&type=script&lang=js&"
export * from "./property-form-page.vue?vue&type=script&lang=js&"
import style0 from "./property-form-page.vue?vue&type=style&index=0&id=60f0cefe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f0cefe",
  null
  
)

export default component.exports